import React, { type PropsWithChildren } from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';

interface Props {
	title: string;
}

const LegendSection = ({ title, children }: PropsWithChildren<Props>) => (
	<Flex direction="column" gap="space.100">
		<Heading as="h2" size="xxsmall">
			{title}
		</Heading>
		<Flex direction="column" gap="space.100" as="ul" xcss={listStyles}>
			{children}
		</Flex>
	</Flex>
);

export default LegendSection;

const listStyles = xcss({
	padding: '0',
	margin: '0',
	listStyleType: 'none',
});
